import { render } from "./SaveList.vue?vue&type=template&id=2022dbf7&scoped=true"
import script from "./SaveList.vue?vue&type=script&lang=js"
export * from "./SaveList.vue?vue&type=script&lang=js"

import "./SaveList.vue?vue&type=style&index=0&id=2022dbf7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2022dbf7"

export default script